import {createGeneralPageEventsAndComponents} from "../components/page-general";
import {expressQuerySelectorAll} from "../common/html";
import {getIcon, getIconsAsync} from "../services/content-service";

window.addEventListener('DOMContentLoaded', () => {
	createGeneralPageEventsAndComponents();
	const iconContentKeyDataAttribute = "data-iconcontentkey";
	const iconEls = expressQuerySelectorAll(document, ".a-link__icon").filter(el => el.getAttribute(iconContentKeyDataAttribute));
	const iconKeys = iconEls.map(el => el.getAttribute(iconContentKeyDataAttribute) || "");
	getIconsAsync(iconKeys.filter((x, i, a) => a.indexOf(x) == i)).then(_ => {
		iconEls.forEach(el => {
			const icon = getIcon(el.getAttribute(iconContentKeyDataAttribute)!.toLocaleLowerCase().replace("icon.", ""));
			if (icon) {
				fetch(icon)
					.then(response => response.text())
					.then(svg => el.insertAdjacentHTML("afterbegin", svg));
			}
		});
	});
});
